import React, { ReactElement, useEffect } from 'react';
import { useParams } from 'react-router-dom';

import LayoutPupDocs from 'pupdocs/components/layout/LayoutPupDocs';
import { useLayoutState } from 'shared/components/layout/useLayoutState';
import { PupDocsRoutes } from 'pupdocs/utilities/const';
import { BreadcrumbItem } from 'types';
import { DetailsContent } from './detailsContent/DetailsContent';
import { DetailsProvider } from './useDetailsState';

export function FileDetails(): ReactElement {
  const { dispatch: dispatchLayout } = useLayoutState();
  const { lineItemId } = useParams<{ lineItemId: string }>();
  useEffect(() => {
    const breadcrumbs: BreadcrumbItem[] = [
      {
        key: 'main',
        label: 'Main',
        path: '/',
      },
      {
        key: 'pupDocs',
        label: 'PupDocs',
      },
      {
        key: 'preFlight',
        label: 'Pre-Flight',
        path: PupDocsRoutes.PreFlight,
      },
      {
        key: 'preFlight',
        label: `Puppy ID: ${lineItemId}`,
      },
    ];
    dispatchLayout({ type: 'SET_BREADCRUMBS', breadcrumbs });
  }, []);

  return (
    <LayoutPupDocs>
      <DetailsProvider>
        <DetailsContent />
      </DetailsProvider>
    </LayoutPupDocs>
  );
}
